module.exports = {
  AppPropTypes: require('./AppPropTypes').default,
  connectRedux: require('./connectRedux').default,
};
